"use strict";

import $ from "jquery";
import Swal from "sweetalert2";
import { lang, tr } from "../../utils/helpers";

const forgotPassword = {
  init() {
    $('#form-recovery-email').on('submit', function (e) {
      e.preventDefault();
      const captcha = grecaptcha.getResponse();

      captcha.length !== 0 ?
        e.target.submit() :
        Swal.fire(tr[lang].modal_error_captcha, '', 'error');
    });
  },
};

export default forgotPassword;
